import script from "./Footer.vue?vue&type=script&lang=ts&setup=true"
export * from "./Footer.vue?vue&type=script&lang=ts&setup=true"

import "./Footer.vue?vue&type=style&index=0&id=791a6146&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-791a6146"]])

export default __exports__